module.exports = __webpack_public_path__ + "static/media/oracle_kids.7cae721e.png";